module.exports = __webpack_public_path__ + "static/mobile1-4d986c6bbeb61243ab46c0c7e4e045a5.png";